export type TranscriberProviderDisplaySource = {
  provider: string;
  providerDisplayName?: string | null;
  language?: string | null;
};

/** Label shown to end users; falls back to the real provider when no pseudonym is set. */
export function resolveTranscriberProviderDisplayName(
  transcriber: TranscriberProviderDisplaySource,
): string {
  const custom = transcriber.providerDisplayName?.trim();
  if (custom) return custom;
  return transcriber.provider || '';
}

/** `displayProvider / language` label used in pickers and lists. */
export function formatTranscriberLabel(transcriber: TranscriberProviderDisplaySource): string {
  const provider = resolveTranscriberProviderDisplayName(transcriber);
  const language = transcriber.language || '';
  return language ? `${provider} / ${language}` : provider;
}

/** Search matches display label and underlying provider (so admins can still find by real name). */
export function transcriberMatchesProviderQuery(
  transcriber: TranscriberProviderDisplaySource,
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const display = resolveTranscriberProviderDisplayName(transcriber).toLowerCase();
  const raw = (transcriber.provider || '').toLowerCase();
  return display.includes(q) || raw.includes(q);
}
